var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    attrs: {
      "delay": 100,
      "name": "paletteModal",
      "width": "70%",
      "height": "auto",
      "pivotY": 0.3
    },
    on: {
      "before-open": _vm.beforeOpen,
      "closed": _vm.closeModal
    }
  }, [_c('section', {
    staticClass: "swatches-palette-modal"
  }, [_c('div', {
    staticClass: "swatches-palette-modal-content"
  }, [_c('div', {
    staticClass: "swatches-palette-modal-content-carousel featuretab"
  }, [_c('carousel', {
    attrs: {
      "per-page": 1,
      "paginationEnabled": false,
      "navigationEnabled": _vm.navigationEnabled,
      "navigationPrevLabel": "<span class='icon-arrow-left-indicator-open'></span>",
      "navigationNextLabel": "<span class='icon-arrow-right-indicator-open'></span>"
    }
  }, _vm._l(_vm.slideData, function (item, index) {
    return _c('slide', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(item.innerHTML)
      }
    });
  }), 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.modalData)
    }
  })]), _c('div', {
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }